/* eslint-disable max-len */
import 'react';

const SelectAllCloseSvg = (
    props: React.SVGProps<SVGSVGElement>
): React.PropsWithoutRef<React.ReactSVGElement> => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="2.93237" y="12.5273" width="13.3333" height="1" rx="0.5" transform="rotate(-45 2.93237 12.5273)" fill="#11141A" />
        <path d="M12.714 12.8808C12.5188 13.0761 12.2022 13.0761 12.0069 12.8808L3.28594 4.15984C3.09068 3.96458 3.09068 3.64799 3.28594 3.45273C3.4812 3.25747 3.79778 3.25747 3.99304 3.45273L12.714 12.1737C12.9093 12.369 12.9093 12.6856 12.714 12.8808Z" fill="#11141A" />
    </svg>

);
export default SelectAllCloseSvg;
